import { useTranslation } from 'react-i18next';

interface ProductFilterProps {
  categories: string[];
  activeCategory: string;
  onCategoryChange: (cat: string) => void;
  sortBy: string;
  onSortChange: (sort: string) => void;
  totalCount: number;
}

const categoryKeyMap: Record<string, string> = {
  '全部': 'filter_all',
  '瓦楞纸': 'category_corrugated',
  '剑麻': 'category_sisal',
  '综合': 'category_combo',
};

export default function ProductFilter({
  categories,
  activeCategory,
  onCategoryChange,
  sortBy,
  onSortChange,
  totalCount,
}: ProductFilterProps) {
  const { t } = useTranslation();

  const sortOptions = [
    { value: 'default', labelKey: 'sort_default' },
    { value: 'price-asc', labelKey: 'sort_price_asc' },
    { value: 'price-desc', labelKey: 'sort_price_desc' },
  ];

  const translateCategory = (cat: string): string => {
    const key = categoryKeyMap[cat];
    return key ? t(key) : cat;
  };

  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 py-6 border-b border-[#f0ebe4]">
      <div className="flex items-center gap-1 bg-[#f5f0eb] rounded-full px-1 py-1 flex-wrap">
        {categories.map((cat) => (
          <button
            key={cat}
            onClick={() => onCategoryChange(cat)}
            className={`px-4 py-1.5 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
              activeCategory === cat
                ? 'bg-[#C8714A] text-white'
                : 'text-[#666] hover:text-[#C8714A]'
            }`}
          >
            {translateCategory(cat)}
          </button>
        ))}
      </div>

      <div className="flex items-center gap-4">
        <span className="text-sm text-[#999]">
          {t('filter_count')}{t('filter_count') ? ' ' : ''}<strong className="text-[#1a1a1a]">{totalCount}</strong> {t('filter_count2')}
        </span>
        <div className="relative">
          <select
            value={sortBy}
            onChange={(e) => onSortChange(e.target.value)}
            className="appearance-none pl-3 pr-8 py-1.5 rounded-lg border border-[#e8e0d8] bg-white text-sm text-[#444] cursor-pointer focus:outline-none focus:border-[#C8714A]"
          >
            {sortOptions.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {t(opt.labelKey)}
              </option>
            ))}
          </select>
          <div className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-down-s-line text-[#999] text-sm"></i>
          </div>
        </div>
      </div>
    </div>
  );
}